import { Routes } from '@angular/router';
import { AppInitializedGuard } from '@y42/app-state';
import { LoginGuard } from '../routing/guards/login.guard';

export const AUTH_ROUTES: Routes = [
  {
    path: 'login',
    canActivate: [LoginGuard],
    children: [],
  },
  // The endpoint is not being called when we manually logout, we are redirected to the login page
  {
    path: 'logout',
    loadComponent: () => import('./logout/logout.component').then((m) => m.LogoutComponent),
  },
  {
    path: 'password/reset/:resetToken',
    title: 'Reset password',
    loadChildren: () => import('./forgot-password/forgot-password.module').then((m) => m.ForgotPasswordModule),
  },
  {
    path: 'two-factor',
    title: 'Two-factor authentication',
    loadChildren: () => import('./two-factor/two-factor.module').then((m) => m.TwoFactorModule),
  },
  {
    path: 'unauthorized',
    canActivate: [AppInitializedGuard],
    loadComponent: () => import('./unauthorized/unauthorized.component').then((m) => m.UnauthorizedComponent),
    title: 'Unauthorized',
  },
];
